import { render, staticRenderFns } from "./pagina-produtos.vue?vue&type=template&id=5fc2eaa0&scoped=true"
import script from "./pagina-produtos.vue?vue&type=script&lang=js"
export * from "./pagina-produtos.vue?vue&type=script&lang=js"
import style0 from "./pagina-produtos.vue?vue&type=style&index=0&id=5fc2eaa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc2eaa0",
  null
  
)

export default component.exports